<div class="dfd-modal">
    <div class="dfd-head">
        <span class="dfd-head-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" width="21" height="21" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M18.84 12.25l1.72-1.71a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
                <path d="M5.17 11.75l-1.71 1.71a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
                <line x1="8" y1="2" x2="8" y2="5"></line>
                <line x1="2" y1="8" x2="5" y2="8"></line>
                <line x1="16" y1="19" x2="16" y2="22"></line>
                <line x1="19" y1="16" x2="22" y2="16"></line>
            </svg>
        </span>
        <div class="dfd-head-text">
            <h2 class="dfd-head-title">Dial failure</h2>
            <span class="dfd-head-sub">{{ whenAbsolute }}</span>
        </div>
        <button type="button" class="dfd-icon-btn dfd-head-close" (click)="close()" aria-label="Close">
            <svg viewBox="0 0 16 16" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.8"><line x1="4" y1="4" x2="12" y2="12"></line><line x1="12" y1="4" x2="4" y2="12"></line></svg>
        </button>
    </div>

    <div class="dfd-body">
        <!-- Connection path: one top-down trace carrying topology + record -->
        <section class="dfd-card">
            <header class="dfd-card-head">
                <span class="dfd-card-title">Connection path</span>
            </header>
            <div class="dfd-card-body dfd-trace">
                @for (row of traceRows; track row.key; let last = $last) {
                    <div class="dfd-hop dfd-hop--{{ row.state }}" [class.dfd-hop--last]="last" [class.dfd-hop--transit]="row.isTransit">
                        <div class="dfd-rail">
                            <span class="dfd-dot">
                                @if (row.state === 'failed') {
                                    <svg class="dfd-dot-x" viewBox="0 0 12 12" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><line x1="3.2" y1="3.2" x2="8.8" y2="8.8"></line><line x1="8.8" y1="3.2" x2="3.2" y2="8.8"></line></svg>
                                }
                            </span>
                        </div>
                        <div class="dfd-hop-body">
                            <div class="dfd-hop-top">
                                <span class="dfd-hop-role">{{ row.role }}</span>
                            </div>
                            <div class="dfd-hop-name-row">
                                @if (row.isTransit) {
                                    @if (row.routers) {
                                        <div class="dfd-routers">
                                            @for (rt of row.routers; track $index) {
                                                @if ($index > 0) { <span class="dfd-router-arrow" aria-hidden="true">→</span> }
                                                @if (rt.link) {
                                                    <a class="dfd-router-name dfd-hop-name--link" [routerLink]="rt.link" (click)="onNavigate()" [matTooltip]="rt.name" matTooltipPosition="above">{{ rt.name }}</a>
                                                } @else {
                                                    <span class="dfd-router-name" [matTooltip]="rt.name" matTooltipPosition="above">{{ rt.name }}</span>
                                                }
                                            }
                                        </div>
                                    } @else {
                                        <div class="dfd-hop-name">{{ row.name }}</div>
                                    }
                                } @else if (row.link) {
                                    <a class="dfd-hop-name dfd-hop-name--link" [routerLink]="row.link" (click)="onNavigate()" [matTooltip]="row.name" matTooltipPosition="above">{{ row.name }}</a>
                                } @else {
                                    <div class="dfd-hop-name" [matTooltip]="row.name" matTooltipPosition="above">{{ row.name }}</div>
                                }
                                @if (row.raw) {
                                    <button
                                        type="button"
                                        class="dfd-icon-btn dfd-hop-copy"
                                        [class.dfd-icon-btn--done]="copiedKey === row.key"
                                        (click)="copy(row.key, row.raw)"
                                        [attr.aria-label]="'Copy ' + row.role"
                                    >
                                        @if (copiedKey === row.key) {
                                            <svg viewBox="0 0 16 16" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 8.5 6.5 12 13 4.5"></polyline></svg>
                                        } @else {
                                            <svg viewBox="0 0 16 16" width="13" height="13" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="5.5" y="5.5" width="8" height="8" rx="1.5"></rect><path d="M10.5 5.5V4A1.5 1.5 0 0 0 9 2.5H4A1.5 1.5 0 0 0 2.5 4v5A1.5 1.5 0 0 0 4 10.5h1.5"></path></svg>
                                        }
                                    </button>
                                }
                            </div>
                            @if (row.routerMeta) {
                                @if (row.hasMorePath) {
                                    <button type="button" class="dfd-path-toggle" (click)="toggleFullPath()" [attr.aria-expanded]="showFullPath">
                                        <span>{{ row.routerMeta }}</span>
                                        <svg class="dfd-path-chevron" [class.dfd-path-chevron--open]="showFullPath" viewBox="0 0 12 12" width="10" height="10" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><polyline points="3 4.5 6 7.5 9 4.5"></polyline></svg>
                                    </button>
                                } @else {
                                    <div class="dfd-hop-sub">{{ row.routerMeta }}</div>
                                }
                            }
                            @if (showFullPath && row.fullPath) {
                                <ul class="dfd-router-path">
                                    @for (rt of row.fullPath; track $index) {
                                        <li class="dfd-router-path-item">
                                            <span class="dfd-router-path-role">{{ rt.role }}</span>
                                            @if (rt.link) {
                                                <a class="dfd-router-path-name dfd-hop-name--link" [routerLink]="rt.link" (click)="onNavigate()" [matTooltip]="rt.name" matTooltipPosition="above">{{ rt.name }}</a>
                                            } @else {
                                                <span class="dfd-router-path-name" [matTooltip]="rt.name" matTooltipPosition="above">{{ rt.name }}</span>
                                            }
                                        </li>
                                    }
                                </ul>
                            }
                            @if (row.sub) {
                                <div class="dfd-hop-sub">{{ row.sub }}</div>
                            }
                        </div>
                    </div>
                }
            </div>
        </section>

        <!-- What happened: demoted diagnosis (reason + remediation) -->
        <section class="dfd-card">
            <header class="dfd-card-head">
                <span class="dfd-card-title">What happened</span>
                @if (errorCode) { <span class="dfd-code">{{ errorCode }}</span> }
            </header>
            <div class="dfd-card-body">
                <p class="dfd-reason">
                    @for (seg of reasonSegments; track $index) {
                        @if (seg.mono) { <span class="dfd-mono">{{ seg.text }}</span> } @else { <span>{{ seg.text }}</span> }
                    }
                </p>
                @if (explanation) {
                    <p class="dfd-explanation">{{ explanation }}</p>
                }
            </div>
        </section>
    </div>
</div>
